import type { RegisteredComponent } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

import { heroDefaultValues } from "../HeroV2/HeroV2.builder";

export const HeroContainerComponent: RegisteredComponent = {
  name: "HeroContainer",
  component: dynamic(() => import("./HeroContainer").then((mod) => mod.HeroContainer)),
  canHaveChildren: true,
  noWrap: true,
  shouldReceiveBuilderProps: {
    builderBlock: true,
    builderComponents: true,
    builderContext: true,
  },
  childRequirements: {
    message: "Only Hero Container related components are allowed",
    query: {
      "component.name": {
        $in: ["Hero"],
      },
    },
  },
  inputs: [
    {
      name: "isContainerWidth",
      type: "boolean",
      defaultValue: false,
    },
    {
      name: "isViewportHeight",
      type: "boolean",
      defaultValue: true,
    },
    {
      name: "mobileMediaAtTop",
      type: "boolean",
      defaultValue: false,
    },
    {
      name: "autoplayEnabled",
      friendlyName: "Autoplay enabled",
      type: "boolean",
      defaultValue: false,
    },
    {
      name: "autoplayDelay",
      friendlyName: "Autoplay delay interval",
      type: "string",
      enum: ["3", "4", "5", "6", "7", "8", "9", "10"],
      defaultValue: "5",
    },
    {
      name: "breadcrumbsSpacing",
      type: "boolean",
      defaultValue: false,
    },
  ],
  defaultChildren: [
    {
      "@type": "@builder.io/sdk:Element",
      component: {
        name: "Hero",
        options: {
          data: heroDefaultValues,
        },
      },
    },
  ],
};
